import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { fmtEur } from "@/lib/format";

export const PrimeChart = ({ sims }) => {
  const data = sims.map((s) => ({
    name: s.name.length > 22 ? `${s.name.slice(0, 21)}…` : s.name,
    ferme: Math.round(s.result?.total_prime || 0),
    options: Math.round(s.result?.options_prime || 0),
  }));
  const hasOptions = data.some((d) => d.options > 0);
  if (data.every((d) => !d.ferme && !d.options)) {
    return <div className="h-40 grid place-items-center text-sm text-muted-foreground text-center" data-testid="prime-chart-empty">Toutes les primes sont à 0 € : aucun tarif en vigueur n'est configuré pour cet espace.</div>;
  }
  return (
    <div className="h-72" data-testid="prime-chart">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 10, right: 10, left: 10, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
          <XAxis dataKey="name" tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 12 }} axisLine={false} tickLine={false} />
          <YAxis tickFormatter={(v) => `${(v / 1000).toLocaleString("fr-FR")} k€`} tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 11 }} axisLine={false} tickLine={false} width={64} />
          <Tooltip formatter={(v, n) => [fmtEur(v), n === "ferme" ? "Prime ferme" : "Options"]} contentStyle={{ background: "hsl(var(--popover))", border: "1px solid hsl(var(--border))", borderRadius: 10 }} cursor={{ fill: "hsl(var(--secondary))" }} />
          {hasOptions && <Legend formatter={(v) => (v === "ferme" ? "Prime ferme" : "Options")} />}
          <Bar dataKey="ferme" stackId="a" fill="rgb(var(--genis))" radius={[0, 0, 0, 0]} />
          {hasOptions && <Bar dataKey="options" stackId="a" fill="rgb(var(--genis-accent))" radius={[6, 6, 0, 0]} />}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
